import { HTTPClient } from '@rjgf/http-client'
import { useTokenStore } from '@/store/token'
import pinia from '@/store'

const tokenStore = useTokenStore(pinia)

export function getToken(): string {
  return tokenStore.getToken()
}

export function setToken(token: string) {
  HTTPClient.setToken(token, 'Bearer')
  return tokenStore.setToken(token)
}

export function removeToken() {
  return tokenStore.removeToken()
}
